export default __webpack_public_path__ + "static/media/solar_radiation-active.7cd59d8e.svg";